var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEllipseCircleGreyTick = function SvgEllipseCircleGreyTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.928,
    cy: 12.773,
    r: 12,
    fill: "#fff",
    stroke: "#C3C3C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    fillRule: "evenodd",
    d: "m21.557 8.673-10.97 10.97-5.491-5.492 2.766-2.767 2.725 2.725 8.203-8.203z",
    clipRule: "evenodd"
  })));
};
export { SvgEllipseCircleGreyTick as ReactComponent };
export default __webpack_public_path__ + "images/EllipseCircleGreyTick.svg";